import { CHAT_EVENTS } from '@conversed/shared/src/central/constants/socket';
import { useCallback } from 'react';

import { Actions } from '../../../constants/actionTypes';
import { useMainDispatch } from '../../useMainDispatch';
import useSocket from '../../useSocket';

const { PLATFROM_TO_CORE_EVENTS: SEND_EVENTS } = CHAT_EVENTS;

export const useChatNotificationsActions = () => {
  const { send } = useSocket();
  const dispatch = useMainDispatch();

  // biome-ignore lint/correctness/useExhaustiveDependencies: uses no actual dependencies
  const addNotification = useCallback(
    (user: string, event: 'newMessage' | 'newUser', timestamp: number) => {
      dispatch({
        type: Actions.ADD_CHAT_NOTIFICATIONS,
        payload: [
          {
            event,
            user,
            timestamp,
          },
        ],
      });
    },
    [],
  );

  const clearNotifications = useCallback(
    (userId: string, timestamp: number) => {
      if (userId) {
        send(SEND_EVENTS.AGENT_READ_NOTIFICATION, {
          userData: {
            chatBotUserId: userId,
          },
          data: timestamp,
        });
      }

      dispatch({
        type: Actions.CLEAR_CHAT_NOTIFICATIONS,
        payload: userId,
      });
    },
    [dispatch, send],
  );

  const clearAllNotifications = useCallback(
    () =>
      dispatch({
        type: Actions.CLEAR_CHAT_NOTIFICATIONS,
        payload: undefined,
      }),
    [dispatch],
  );

  return { addNotification, clearNotifications, clearAllNotifications };
};
